import apiFetch from '../../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `ControlSangre/getFiltrarModalInicio`, method: 'POST', body: values, token: token})
}
